import { ELanguageCode, TranslationItem } from '@/schemaTypes'

export const getTranslatedText = (
  allTranslations: TranslationItem[],
  language: ELanguageCode | string,
) => {
  return allTranslations.find((a) => a.languageCode === language)?.text
}
